/* predictive-search.js — Alkaram-style panel under header */

document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("[data-predictive-search]");
  if (!root) return;

  const openBtn = root.querySelector("[data-search-open]");
  const closeBtn = root.querySelector("[data-search-close]");
  const panel = root.querySelector("[data-search-panel]");
  const input = root.querySelector("[data-search-input]");
  const resultsEl = root.querySelector("[data-search-results]");

  let debounceTimer;
  let currentController;

  const setPanelTop = () => {
    const headerGroup = document.querySelector(".shopify-section-group-header-group");
    const top = headerGroup
      ? Math.round(headerGroup.getBoundingClientRect().bottom)
      : Math.round(document.querySelector(".section-header")?.getBoundingClientRect().bottom || 110);
    document.documentElement.style.setProperty("--search-panel-top", `${Math.max(top, 0)}px`);
  };

  const open = () => {
    setPanelTop();
    // Keep panel under <body> so header transforms never trap position:fixed
    if (panel.parentElement !== document.body) {
      document.body.appendChild(panel);
    }
    panel.hidden = false;
    document.body.classList.add("search-open");
    setTimeout(() => input.focus(), 50);
  };

  const close = () => {
    panel.hidden = true;
    document.body.classList.remove("search-open");
    resultsEl.innerHTML = "";
    input.value = "";
  };

  openBtn.addEventListener("click", open);
  closeBtn.addEventListener("click", close);
  panel.addEventListener("click", (e) => {
    if (e.target === panel) close();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
  window.addEventListener("resize", () => {
    if (!panel.hidden) setPanelTop();
  });
  window.addEventListener(
    "scroll",
    () => {
      if (!panel.hidden) setPanelTop();
    },
    { passive: true }
  );

  input.addEventListener("input", () => {
    clearTimeout(debounceTimer);
    const query = input.value.trim();

    if (query.length < 2) {
      resultsEl.innerHTML = "";
      return;
    }

    debounceTimer = setTimeout(() => runSearch(query), 220);
  });

  async function runSearch(query) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    const url = `${window.Shopify?.routes?.root || "/"}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last`;

    try {
      const res = await fetch(url, { signal: currentController.signal });
      const data = await res.json();
      renderResults(data.resources.results, query);
    } catch (err) {
      if (err.name !== "AbortError") console.error(err);
    }
  }

  function renderResults(results, query) {
    const products = results.products || [];
    const collections = results.collections || [];
    const queries = results.queries || [];

    if (!products.length && !collections.length) {
      resultsEl.innerHTML = `<p class="search-empty">No results for "${escapeHtml(query)}". Press enter to see full results.</p>`;
      return;
    }

    let html = "";

    if (queries.length) {
      html += `<div class="search-group"><h4>Suggestions</h4><ul>`;
      queries.forEach((q) => {
        html += `<li><a href="${q.url}">${q.styled_text}</a></li>`;
      });
      html += `</ul></div>`;
    }

    if (collections.length) {
      html += `<div class="search-group"><h4>Collections</h4><ul>`;
      collections.forEach((c) => {
        html += `<li><a href="${c.url}">${escapeHtml(c.title)}</a></li>`;
      });
      html += `</ul></div>`;
    }

    if (products.length) {
      html += `<div class="search-group search-group-products"><h4>Products</h4><div class="search-product-grid">`;
      products.forEach((p) => {
        html += `
          <a href="${p.url}" class="search-product">
            <img src="${p.featured_image ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, "_240x$1$2") : ""}" alt="${escapeHtml(p.title)}" width="60" height="80" loading="lazy">
            <div>
              <div class="search-product-title">${escapeHtml(p.title)}</div>
              <div class="search-product-price">${p.price}</div>
            </div>
          </a>`;
      });
      html += `</div></div>`;
    }

    resultsEl.innerHTML = html;
  }

  function escapeHtml(str) {
    const div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }
});
